import React from 'react';
import { Navigate } from 'react-router-dom';

const RequireAuth = (props) => {
    if (props.resourcePageName === 'error' && props.resource_path === '*') {
        return <Navigate to="/404" />;
    }

    //外链形式
    if (props.resource_source === 4) {
        return (
            <div style={{ width: '100%', height: 'calc(100vh - 120px)' }}>
                <iframe style={{ height: '100%', width: '100%' }} src={props.resource_path} frameborder="0"></iframe>
            </div>
        );
    }
};

export default RequireAuth;
